/**
 * progressReportConverters.js
 *
 * DashboardProgressReportPageから抽出された純粋関数群
 * 進捗報告固有のデータ変換ロジックを提供
 */

// 進捗状況は3種類の天気アイコンに統一する（画面表示・保存値ともにこの3種のみ）
export const PROGRESS_STATUS_SUNNY = '☼'; // 晴れ（順調）
export const PROGRESS_STATUS_CLOUDY = '☁'; // 曇り（注意）
export const PROGRESS_STATUS_RAINY = '☂'; // 雨（遅延・問題）

// 過去データ・Notion由来・アプリ内部値など、あらゆる表記を3種へ寄せるための別名表
const PROGRESS_STATUS_ALIASES = {
  '☀': PROGRESS_STATUS_SUNNY, // Notionの晴れ絵文字
  '☼': PROGRESS_STATUS_SUNNY,
  高: PROGRESS_STATUS_SUNNY,
  晴: PROGRESS_STATUS_SUNNY,
  晴れ: PROGRESS_STATUS_SUNNY,
  '☁': PROGRESS_STATUS_CLOUDY,
  中: PROGRESS_STATUS_CLOUDY,
  曇: PROGRESS_STATUS_CLOUDY,
  曇り: PROGRESS_STATUS_CLOUDY,
  '☂': PROGRESS_STATUS_RAINY,
  '☔': PROGRESS_STATUS_RAINY,
  低: PROGRESS_STATUS_RAINY,
  雨: PROGRESS_STATUS_RAINY,
};

/**
 * 進捗状況を3種類の天気アイコン（☼/☁/☂）に正規化する
 * @param {string|null|undefined} value - 生の進捗状況値
 * @returns {string} 正規化後のアイコン（未知・空値は晴れ ☼ にフォールバック）
 */
export function normalizeProgressStatusIcon(value) {
  if (value === null || value === undefined) return PROGRESS_STATUS_SUNNY;
  const key = String(value).trim();
  return PROGRESS_STATUS_ALIASES[key] || PROGRESS_STATUS_SUNNY;
}

/**
 * 複数キーに対して、行データから一意な値を抽出してセレクトボックス用のオプションを生成（進捗報告用）
 * @param {Array} rows - データ行の配列
 * @param {Array} keys - 抽出対象のキー名配列
 * @returns {Object} キーごとのオプション配列 { key: ['', value1, value2, ...] }
 */
export function buildSelectOptions(rows, keys) {
  const optionsByKey = Object.fromEntries(keys.map((key) => [key, new Set()]));

  rows.forEach((row) => {
    keys.forEach((key) => {
      const value = row[key];
      if (value !== undefined && value !== null && value !== '') {
        optionsByKey[key].add(value);
      }
    });
  });

  return Object.fromEntries(
    Object.entries(optionsByKey).map(([key, values]) => [key, ['', ...Array.from(values)]]),
  );
}
